import React, { useState } from 'react';
import {
  Modal, Box, Typography, IconButton, CircularProgress, Button,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlannerSessionGoals from './PlannerSessionGoals';
import PlannerDiscussionMessages from './PlannerDiscussionMessages';
import SessionDiscussionEditor from './SessionDiscussionEditor';
import PlannerSessionGoalsEditor from './PlannerSessionGoalsEditor';
import usePlannerData from './usePlannerData';
import PlannerTriagerDialog from './PlannerTriagerDialog';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  maxHeight: '90vh',
  overflow: 'hidden'
};

const MODULE_OPTIONS = ['profits','cards', 'listings', 'agent', 'tools', 'purchaserequests', 'template_generator'];

const PlannerSessionGoalsModal = ({ open, onClose, sessionId }) => {
  const [triageOpen, setTriageOpen] = useState(false);
  const {
    goals,
    newGoal,
    setNewGoal,
    handleAddGoal,
    loading,
    error,
    messages,
    newMessage,
    setNewMessage,
    fetchDiscussionMessages,
    setDiscussionLogs
  } = usePlannerData(sessionId, open);

  const [selectedModule, setSelectedModule] = useState('cards');

  if (!sessionId) return null;

  const onSendComplete = () => {
    fetchDiscussionMessages(sessionId).then(data => {
      setDiscussionLogs(data);
    });
  };

  return (
    <>
      <Modal open={open} onClose={onClose} style={{ zIndex: 1300 }}>
        <Box sx={modalStyle} display="flex" flexDirection="column" height="100%">
          {/* Header */}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Manage Goals for Session {sessionId}</Typography>
            <Box>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setTriageOpen(true)}
                sx={{ mr: 1 }}
              >
                Open Triage
              </Button>
              <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </Box>
          </Box>

          {/* Module picker */}
          <Box mt={2}>
            <FormControl fullWidth>
              <InputLabel id="planner-module-select-label">Module</InputLabel>
              <Select
                labelId="planner-module-select-label"
                label="Module"
                value={selectedModule}
                onChange={(e) => setSelectedModule(e.target.value)}
                size="small"
              >
                {MODULE_OPTIONS.map((m) => (
                  <MenuItem key={m} value={m}>{m}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Main content */}
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error" align="center">{error}</Typography>
          ) : (
            <>
              <PlannerSessionGoals goals={goals} />
              <PlannerSessionGoalsEditor
                newGoal={newGoal}
                setNewGoal={setNewGoal}
                handleAddGoal={handleAddGoal}
              />
              <Box mt={2} flex={1} overflow="auto" border={1} borderColor="grey.300" p={2} borderRadius={2}>
                <PlannerDiscussionMessages messages={messages} />
              </Box>
              <SessionDiscussionEditor
                sessionId={sessionId}
                onSendComplete={onSendComplete}
                newMessage={newMessage}
                setNewMessage={setNewMessage}
                moduleName={selectedModule}
              />
            </>
          )}
        </Box>
      </Modal>

      {/* Full-screenish Triager Dialog */}
      <PlannerTriagerDialog
        open={triageOpen}
        onClose={() => setTriageOpen(false)}
        moduleName={selectedModule}
      />
    </>
  );
};

export default PlannerSessionGoalsModal;
